module.exports = __webpack_public_path__ + "public/img/promo-1.21c1e78a.jpg";